import { useCallback } from 'react';
import { Intervention } from '@/types';
import {
  useGetAllPathwayScenariosQuery,
  useLazyGetPathwayScenarioQuery,
  useSavePathwayScenarioMutation,
} from '@/api/pathway-scenarios';
import { identify } from '@/data/identify';

// Data layer for the "copy intervention to scenario" feature. Lives in a hook
// (not the component) so the API calls stay out of ./src/components and the two
// call sites (scenario sidebar + scenario assumptions) share one implementation.
const useCopyIntervention = () => {
  const { data: scenarios = [] } = useGetAllPathwayScenariosQuery();
  const [getPathwayScenario] = useLazyGetPathwayScenarioQuery();
  const [savePathwayScenario] = useSavePathwayScenarioMutation();

  const copyIntervention = useCallback(
    async (targetPathwayScenarioId: number, intervention: Intervention) => {
      const target = await getPathwayScenario(targetPathwayScenarioId).unwrap();
      const copied = identify({ ...intervention, id: undefined });
      await savePathwayScenario({
        ...target,
        interventions: [...target.interventions, copied],
      }).unwrap();
    },
    [getPathwayScenario, savePathwayScenario],
  );

  return { scenarios, copyIntervention };
};

export { useCopyIntervention };
